<mat-form-field class="w-100" appearance="outline">
    <mat-label>{{ label | translate }}</mat-label>

    <input matInput readonly
        [matDatepicker]="picker"
        [formControlName]="fieldName"
        [required]="required"
        (click)="picker.open()">
    <mat-icon *ngIf="!required" matSuffix class="mat-datepicker-toggle clickable" (click)="clearField()">clear</mat-icon>
    <mat-datepicker #picker startView="multi-year" (yearSelected)="onYearSelected($event, picker)"></mat-datepicker>
    
    <mat-error *ngIf="getFormControlField()?.hasError('required')">
        {{ 'data-table.modal.validation-error.field-required' | translate }}
    </mat-error>
</mat-form-field>
